/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where an event is relative to its availability window.
 * @export
 */
export const EventState = {
    Upcoming: 'upcoming',
    Open: 'open',
    Closed: 'closed'
} as const;
export type EventState = typeof EventState[keyof typeof EventState];


export function instanceOfEventState(value: any): boolean {
    for (const key in EventState) {
        if (Object.prototype.hasOwnProperty.call(EventState, key)) {
            if (EventState[key as keyof typeof EventState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventStateFromJSON(json: any): EventState {
    return EventStateFromJSONTyped(json, false);
}

export function EventStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventState {
    return json as EventState;
}

export function EventStateToJSON(value?: EventState | null): any {
    return value as any;
}

export function EventStateToJSONTyped(value: any, ignoreDiscriminator: boolean): EventState {
    return value as EventState;
}

